import { INotification } from "constant/interfaces";

interface IProps {
  item: INotification;
}
const Seen: React.FC<IProps> = ({ item }) => {
  return (
    <div className="px-[11px] py-1 border border-[#d9d9d9] bg-[rgba(0,0,0,0.04)]" data-disabled>
      {item?.notification_views?.map(x => x.name).join(", ")}
    </div>
  );
};

export default Seen;
